import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { propShape, propStr } from '../../../../helpers/custom-prop-types';
import InputError from '../../Common/InputError';
import PlainInput from '../../Common/PlainInput';
const RegistrationTextField = (props) => {
    const { input, label, meta, placeholder, type } = props;
    return (_jsx("div", Object.assign({ className: 'field' }, { children: _jsxs("label", { children: [_jsx("div", Object.assign({ className: 'label' }, { children: label })), _jsx("div", Object.assign({ className: 'input_content' }, { children: _jsx(PlainInput, { className: '', id: input.name, input: input, meta: meta, placeholder: placeholder, type: type }) })), _jsx(InputError, { meta: meta })] }) })));
};
RegistrationTextField.propTypes = {
    input: propShape().isRequired,
    label: propStr().isRequired,
    meta: propShape().isRequired,
    placeholder: propStr().isRequired,
    type: propStr().isRequired,
};
export default RegistrationTextField;
